import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzTableModule } from 'ng-zorro-antd/table';

@Component({
  selector: 'app-tco-table',
  standalone: true,
  imports: [CommonModule, FormsModule, NzTableModule],
  templateUrl: './tco-table.component.html',
  styleUrl: './tco-table.component.scss'
})
export class TcoTableComponent {

  @Input()
  source: 'overlap' | 'duplicate' | 'unique' = 'unique';
  @Input() resetSelection: boolean = false;
  @Input() uniqueFromDuplicateIds: string[] = [];
  @Input()
  dataList: any[] = [
    {
      key: '1',
      name: 'John Brown',
      age: 'Attempt to register a customer with a duplicate email address',
      address: 'As an Admin, I want to register a customer so I can ensure that the customer is properly set up in the system, allowing them to access services and make purchases',
      isDefault: true
    },
    {
      key: '2',
      name: 'Jim Green',
      age: 42,
      address: 'London No. 1 Lake Park',
      isUnique: true
    },
    {
      key: '3',
      name: 'Joe Black',
      age: 32,
      address: 'Sidney No. 1 Lake Park'
    }
  ];

  @Output() onRowSelect = new EventEmitter();

  checked = false;
  indeterminate = false;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['resetSelection'] && changes['resetSelection'].currentValue === true) {
      this.checked = false; // reset header checkbox
    }
    // Mark isUnique and isDefault for test cases in uniqueFromDuplicateIds
  if (this.uniqueFromDuplicateIds && this.dataList) {
    this.dataList.forEach(tc => {
      if (this.uniqueFromDuplicateIds.includes(tc.testId?.toString())) {
        tc.isUnique = true;
        tc.isDefault = true;
      } else {
        tc.isDefault = false;
      }
    });
  }
  }
  onItemChecked(item: any, event: any): void {
    item.checked = event.target.checked;
    this.onRowSelect.emit({
      list: this.dataList.filter((ele: any) => ele.checked)
    });
  }
  oneItemCheckedAtOnce(selectedItem: any, event: any): void {
    const isChecked = event.target.checked;
  
    // Uncheck all items first
    this.dataList.forEach(item => item.checked = false);
  
    // If the clicked checkbox was checked, mark it as the only selected item
    if (isChecked) {
      selectedItem.checked = true;
    }
  
    // Emit the updated selection
    this.onRowSelect.emit({
      list: this.dataList.filter(item => item.checked)
    });
  }
  

  onAllChecked(event: any): void {
    this.dataList.forEach((item: any) => item.checked = event.target.checked);
    this.onRowSelect.emit({
      list: this.dataList.filter((ele: any) => ele.checked)
    });
  }

}
